/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/

export interface IServiceAuthentication {
    Authenticated: boolean;
    UserName: string;
    UserRetreived: boolean;
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    Roles: Array<string>;
}

export class ServiceAuthentication implements IServiceAuthentication {
    Authenticated: boolean;
    UserName: string;
    UserRetreived: boolean;
    FirstName: string;
    LastName: string;
    Email: string;
    Password: string;
    Roles: Array<string>;
    Token: string;
    TokenExpires: string;
}